import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from './login.service';
import { Subject } from 'rxjs';
import { retryWhen, delay, take, tap } from 'rxjs/operators';
import { VersionControlService } from './version-control.service';
@Injectable({
  providedIn: 'root'
})
export class CommerrorService {

  Error: string;
  ErrorType: string;
  logError = false;
  ecnext$ = new Subject<any>();
  
  saveCalendar$ = new Subject<any>();
  saveConcent$ = new Subject<any>(); 
  calendarForm=false;
  concentForm = false;
  sessionExpiration: boolean = false;

  isCardio = false;
  save =false;

  constructor(private http: HttpClient,public versionService: VersionControlService) { 
    this.ErrorType="";
  }

  handleCommError(error: HttpErrorResponse, request: any){
    this.calendarForm = null;
    console.log(error);
    this.logError = false;
    if(error.url.indexOf('http://localhost:8088/alive')> -1)//local server doesn't exist
      return;
    if (error.error instanceof ErrorEvent) {
      this.ErrorType="Network";
      this.Error = "Network Error: Please check your network connection and try again."

    } else {
      if(error.status == 401 && error.error["error"] == "missing user or pw")
        return;//don't display error
      if(error.status == 409) {
        this.ErrorType = 'Server';
        this.Error = (error.error && error.error['error']) ? error.error['error'] : 'Conflict: the operation could not be completed.';
        return;
      }

      if (error.status === 200) {
        return;
      }
      if (error.status === 400) {
        return
      }

      if(error.status == 401 && error.error["error"] == "need to login"){
        this.ErrorType="Session";
        this.Error = "Your session has expired. Please login."
        }
      else{
         if (error.status === 426) {
           this.versionService.triggerVersionMismatch();
           return; 
         }
         if (this.ErrorType === 'VERSION_MISMATCH'){
           return
         }        
        if(error.status == 0){
          this.ErrorType = "Can not reach server";
          this.Error = "Please halt your work until connection is established";
    
          if (request && request.method === 'POST') {
            const failedRequests = JSON.parse(localStorage.getItem('failedRequests')) || [];
            failedRequests.push(request);
            localStorage.setItem('failedRequests', JSON.stringify(failedRequests));
          }
        }else{
          this.ErrorType= "Server";
          this.Error = error.status + ": " + JSON.stringify(error);
          if(error["error"] && error.error["error"]){
            if(typeof error.error["error"] == "string")
              this.Error = error.status + ": " + error.error["error"];
            else
              this.Error = error.status + ": " + JSON.stringify(error.error["error"]);
          }
        }
      }
    }

  }

  error(data, loginerror=false){
    this.calendarForm = null;
    this.ErrorType=data;
    this.logError = loginerror;
    // this.Error="A TodayList has to be generated before a new exam can be opened!"
  }

  errorCardio(data, loginerror=false){
    this.calendarForm = null;
    this.ErrorType=data;
    this.logError = loginerror;
    this.isCardio = true;
    this.sessionExpiration = false
    // this.Error="A TodayList has to be generated before a new exam can be opened!"
  }

  errorGastro(title, data){
    this.calendarForm = null;
    this.ErrorType = title;
    this.Error = data;
    this.sessionExpiration = false
  }

  errorCalendar(data = null){
    this.Error = data;
    this.ErrorType = 'Save this Pregnancy planner';
    this.calendarForm = true;
    this.concentForm = false;
    this.sessionExpiration = false

    if(data){
      this.concentForm = true;
      this.ErrorType = data
    }

  }

  errorSession(errorType: string, errorMessage: string){
    this.calendarForm = null;
    this.concentForm = false;
    this.sessionExpiration = true
    this.ErrorType = errorType;
    this.Error = errorMessage;
  }

  resetErr(){
    this.Error=null;
    this.ErrorType="";

  }
  
  retryRequest(request: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Set the appropriate content type
      // Add any other headers as needed
    });
    return this.http.request(request.method, request.url, {
      body: request.body,
      headers:headers,
      responseType: request.responseType,
    });
  }

  retryFailedRequests() {
    const failedRequests = JSON.parse(localStorage.getItem('failedRequests')) || [];
  
    if (failedRequests.length > 0) {
      // Try to resend each failed request
      failedRequests.forEach((request: any) => {
        this.retryRequest(request).pipe(
          retryWhen(errors =>
            errors.pipe(
              // Delay the retry attempt, you can adjust the delay time as needed
              delay(5000),
              // Only retry for a maximum of 5 times, you can adjust the number of retries as needed
              take(5),
              // Log the error for debugging (optional)
              tap(error => console.log('Retrying request:', error))
            )
          )
        ).subscribe(
          (response) => {
            // Handle successful response (if needed)
            console.log('Request resent successfully:', response);
          },
          (error) => {
            // Handle error on retry (if needed)
            console.error('Failed to resend request:', error);
          }
        );
      });
  
      // Clear the stored failed requests in local storage after attempting to resend them
      localStorage.removeItem('failedRequests');
    }
  }
}
